<template>
  <div>
    <h2 class="careering">iOS Engineer</h2>
    <p1
      >Help give life to the digital connections that reverberate in our
      physical world.</p1
    >
    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <p3>
      <b>You’ll be joining</b> a versatile team of two.
      <a href="https://twitter.com/thecpe" target="_blank">Yatú</a> keeps us
      moving as the Head of Reality, while
      <a href="https://twitter.com/usbnorm" target="_blank">Norm</a> keeps us
      imagining as the Head of Fiction. We’re based in New York City building a
      worldwide network.
    </p3>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <FadedImage name="on-the-go.png" />
    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <p3>
      <b>We're looking for</b> an iOS Engineer who embodies our spirit of rapid
      learning and building the essentials. As a crucial member of the team,
      you’ll help take possibilities from the drawing board to the lived
      experience of USB Club members.
    </p3>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <p3>You’ll shape our on-the-go experience by:</p3>
    <ul>
      <li>Crafting a suite of mobile tools and experiences.</li>
      <li>Researching and prototyping new capabilities.</li>
      <li>Architecting, implementing, and maintaining quality codebases.</li>
      <li>Integrating mobile experiences with our product ecosystem.</li>
    </ul>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <p3>Skillsets for the role include: </p3>
    <ul>
      <li>Proficiency in Obj-C and Swift.</li>
      <li>Experience with releasing and growing an iOS App.</li>
      <li>Experience with embedding motion in digital experiences.</li>
      <li>Ability to articulate complex technical concepts effectively.</li>
    </ul>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <p3>
      <b>The application process</b> will include a chat with Yatú followed by a
      technical challenge with Norm.
    </p3>
    <div class="spacer"></div>
    <p3
      >To kickstart this process, reach out to
      <span class="email">y@usbclub.net</span> with your resume, portfolio, and
      a brief explanation of why you’re interested in being a part of the
      journey at USB Club.
    </p3>
    <div class="spacer"></div>
    <p3
      >We’re committed to creating an encouraging environment for all
      collaborators and teammates, and we look forward to hearing from you.
    </p3>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="spacer"></div>
    <div class="spacer"></div>

    <Footer :fixed="false" />
  </div>
</template>

<script>
import Footer from "../Footer.vue";
import FadedImage from "../FadedImage.vue";

export default {
  name: "iOSEngineer",
  components: {
    Footer,
    FadedImage,
  },
  head() {
    return {
      title: "iOS Engineer",
      meta: [
        {
          tagDuplicateStrategy: "replace",
          name: "twitter:title",
          content: "iOS Engineer",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "twitter:description",
          content: "Career with us.",
        },
        {
          name: "description",
          content: "Career with us.",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "og:description",
          content: "Career with us.",
        },
        {
          tagDuplicateStrategy: "replace",
          name: "og:title",
          content: "iOS Engineer",
        },
      ],
    };
  },
};
</script>
